var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    ref: "swatchesViewTabs",
    attrs: {
      "elementType": "div",
      "customClass": "swatches-view-wrapper organism"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "elementType": "ul",
      "customClass": ['swatches-view-wrapper-tabs', {
        'splash-swatches-view-tabs': _vm.isMobile
      }]
    }
  }, [_vm.isRandomizeEnabled ? _c('tab-randomize') : _vm._e(), _vm._l(_vm.$props.tabs, function (tab) {
    return _c('tab', {
      key: tab.name,
      attrs: {
        "tab": tab
      }
    });
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }